import * as React from "react";
import { Util } from "@grandvisionhq/common";
/* empty css                  */
const LocationList = ({ children, scrollToTargetId, scrollContainer }) => {
  const locationRefs = React.useRef({});
  React.useEffect(() => {
    if (scrollToTargetId) {
      const targetElem = locationRefs.current[scrollToTargetId];
      if (targetElem) {
        const offset = targetElem.offsetTop;
        if (scrollContainer) {
          Util.scrollToItem(scrollContainer, offset, 500);
        } else {
          window.scrollTo(0, offset);
        }
      }
    }
  }, [scrollToTargetId, scrollContainer]);
  return children.length > 0 ? /* @__PURE__ */ React.createElement("ul", { className: "location-list" }, React.Children.map(children, (child) => /* @__PURE__ */ React.createElement(
    "li",
    {
      key: child.key,
      className: "location-list__item",
      ref: (el) => {
        locationRefs.current[child.key ?? ""] = el;
      }
    },
    child
  ))) : null;
};
export {
  LocationList as default
};
//# sourceMappingURL=LocationList.js.map
